export default __webpack_public_path__ + "static/media/OSM-slider3.eb814f22.jpg";